import React from "react"
import { Dropdown } from "primereact/dropdown"
import { ErrorMessage } from "formik"
import { useTranslation } from "react-i18next"

const CustomDropdown = ({
  name,
  value,
  options,
  placeholder,
  onChange,
  optionLabel,
  optionValue,
  className = "",
  isDefaultOption = true,
  isInvalid = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation()

  const dropdownOptions = isDefaultOption
    ? [{ [optionLabel]: t("Select Option"), [optionValue]: "" }, ...options]
    : options

  return (
    <div className="w-100 custom_dropdown">
      <Dropdown
        id={name}
        name={name}
        value={value}
        options={dropdownOptions}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder}
        className={`w-100 ${className}`}
        onChange={onChange}
        filter
        appendTo="self"
        invalid={isInvalid}
        disabled={isDisabled}
      />
    </div>
  )
}

export default CustomDropdown
